import React from 'react';
import { useTheme } from '@sky-distribution/react-commons-ui';
import { isMobile } from 'react-device-detect';
import { StyledButtonContent, StyledMakeCallButton } from './makeCallButton.styles';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { useConfigValuesContext } from '../../common/contexts/ConfigValues/useConfigValuesContext';
import { Tenant, TENANT_NAME } from '../../config/tenants';
import { useIsTenant } from '../../config/utils/useIsTenant';
import { ReactComponent as TuwPhoneIcon } from '../../icons/tuw/phone.svg';

export const MakeCallButton: React.FC = () => {
  const theme = useTheme();
  const { t } = useTypedTranslate();
  const { configValues } = useConfigValuesContext();
  const isTuw = useIsTenant(Tenant.TUW);

  const consultantPhoneNumber = configValues[TENANT_NAME].assistancePhoneNumber;
  const isTuwTabletAndAbove = isTuw && !isMobile;

  const handleCall = (): void => {
    window.location.assign(`tel:${consultantPhoneNumber}`);
  };

  return (
    <StyledMakeCallButton
      onClick={handleCall}
      typeStyle="primary"
      style={isTuw ? { color: theme.palette.button.text.primary.base } : undefined}
    >
      {isTuwTabletAndAbove ? (
        <StyledButtonContent>
          <TuwPhoneIcon />
          {t('MAKE_CALL_TO_US')}
        </StyledButtonContent>
      ) : isMobile ? (
        t('MAKE_CALL_TO_US')
      ) : (
        `${t('MAKE_CALL_AT')} ${consultantPhoneNumber}`
      )}
    </StyledMakeCallButton>
  );
};
